export class CloudResourceSecurityProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "muteAlerts",
            "baseName": "muteAlerts",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "updatedTime",
            "baseName": "updatedTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return CloudResourceSecurityProperties.attributeTypeMap;
    }
    constructor() {
    }
}
